module.exports = __webpack_public_path__ + "static/codehike-97da61a5d0c7f76e73c7ae6487279cec.png";